import { OfficialFormatDateWithYear } from "../../../utilities/FormatDate";
import { PostApi, CalculateBiomarkersByPatientPath } from "../../apis/Api";


/**
 * Calculate Custom Biomarkers for a patient given a list of feeding timestamps
 * 
 * @description Generates custom biomarkers for a patient based on the provided feeding timestamps and options. It calculates the biomarkers by making the request one by one.
 * 
 * @param {*} patient_id Patient ID
 * @param {*} feedings List of List of feeding timestamps to generate biomarkers [1763751470, 1763754870, ...]
 * @param {*} options Biomarker generation options
 * @returns 
 */
async function CalculateCustomBiomarkers(patient_id, feedings, options) {

    const biomarkers = [];
    for (const timestamp of feedings) {
        await PostApi(CalculateBiomarkersByPatientPath(), {
            feeding_session_timestamp: timestamp,
            patient_id: patient_id,
            options: options
        })
        .then(async response => {
            // Temporary fix: Handle invalid JSON with NaN values by converting to string "NaN"
            // TODO: Server should return null or proper values instead of NaN
            const text = await response.text();
            const sanitizedText = text.replace(/:\s*NaN/g, ': "NaN"');
            return JSON.parse(sanitizedText);
        })
        .then(data => {
            if (data.result) {
                // Convert array of {biomarker_name, value} to array of single-key objects
                const biomarkerObjects = data.result.map(item => ({
                    [item.biomarker_name.toLowerCase()]: item.value
                }));

                const feedingData = [
                    { feeding_session_timestamp: timestamp },
                    ...biomarkerObjects
                ];
                biomarkers.push(feedingData);
            }
        });
    }

    return biomarkers;
}
export default CalculateCustomBiomarkers;